// extracted by mini-css-extract-plugin
export var footer = "_mh-0";
export var inherit = "_mh-1";
export var input = "_mh-2";
export var modalContent = "_mh-3";
export var quillEditor = "_mh-4";
export var subtitle = "_mh-5";